export default __webpack_public_path__ + "static/media/huskerbeach-192.359d6194.png";